var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXxcoinLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 306.82 306.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #14b8ca;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 153.41,
    cy: 153.41,
    r: 153.41
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.19,103.3a64.7,64.7,0,0,1,5.87,26.94c0,.3.05.59.06.89l31.23-27.75V70.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.16,130.24c0-33.06-29.57-60-65.93-60V95c22.19,0,40.3,15.09,41.11,33.9l-16.81,14.93a65.3,65.3,0,0,1,8.39,25.64l15-13.32c10.66,20.1,33.29,34,59.43,34V165.44C205.64,165.44,187.16,149.65,187.16,130.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.59,236.36V211.62c-22.71,0-41.19-15.8-41.19-35.21,0-33.06-29.58-59.95-65.94-59.95V141.2c19.3,0,35.5,11.42,39.94,26.76l-8.69,7.72-18,16h0L78.46,203.44v33.1l45-40C132.61,219.73,157,236.36,185.59,236.36Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXxcoinLogo);
export default __webpack_public_path__ + "static/media/xxcoin-logo.20e508c9101fca6d3523f8126e74ca6d.svg";
export { ForwardRef as ReactComponent };